import React from 'react';
import { useTranslation } from 'react-i18next';
import { RescuePlacementModel, useRescuePlacementNavigator } from '../rescuePlacementUtils';
import PetView from '../PetView/PetView';
import styles from './PetSelector.module.scss';

export default function PetSelector({ model }: { model: RescuePlacementModel }) {
  const { t } = useTranslation();
  const navigator = useRescuePlacementNavigator();

  return (
    <div className={styles.main}>
      <div>
        <h2>{t('select_the_dog_you_want_to_place')}</h2>
        {model.petsToBePlaced.map((pet) => (
          <PetView
            key={pet.id}
            title={pet.name}
            pet={pet}
            onClick={() => navigator.go({ placementView: 'petPlacement', petId: pet.id })}
          />
        ))}
        {model.petsToBePlaced.length === 0 && <p>{t('there_are_no_dogs_to_be_placed')}</p>}
      </div>
      <div>
        <h2>{t('select_a_dog_to_recall_into_the_rescue')}</h2>
        {model.petsToBeRecalled.map((pet) => (
          <PetView
            key={pet.id}
            pet={pet}
            title={pet.name}
            onClick={() => navigator.go({ placementView: 'petRecall', petId: pet.id })}
          />
        ))}
        {model.petsToBeRecalled.length === 0 && <p>{t('there_are_no_dogs_to_be_recalled')}</p>}
      </div>
    </div>
  );
}
